import getStore from '../store/store';
/**
 * Gets shareable calendars of shared calendar options store
 */
export default function () {
    return getStore().calendars;
}
//# sourceMappingURL=getCalendarSharingCalendars.js.map